<style scoped lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/wo/delete/record/listByPage" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('shengchangongdanhao')">
            <el-input v-model="yt.conditions.woNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('ERPgongdanhao')">
            <el-input v-model="yt.conditions.erpWoNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shebeimingcheng')">
            <yi_data_select :multiple="true" :type="'equipment'" :ids.sync="yt.conditions.equipmentIds"> </yi_data_select>
            <!--						<yi_cross_select multiple :component="'web_base_equipment_list'"-->
            <!--							:ids.sync="yt.conditions.equipmentIds">-->
            <!--						</yi_cross_select>-->
          </el-form-item>
          <el-form-item :label="$t('mujumingcheng')">
            <yi_cross_select multiple :component="'web_base_mould_list'" :ids.sync="yt.conditions.mouldIds"> </yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('chanpinmingcheng')">
            <yi_data_select :multiple="true" :type="'material2'" :ids.sync="yt.conditions.materialIds"> </yi_data_select>
            <!--						<yi_cross_select multiple :component="'web_base_matter_list'" :ids.sync="yt.conditions.materialIds">-->
            <!--						</yi_cross_select>-->
          </el-form-item>

          <el-form-item :label="$t('shanchushijian')">
            <yi_time_input type="datetimerange" :start.sync="yt.conditions.createTimeStart" :end.sync="yt.conditions.createTimeEnd"> </yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('shanchucaozuoren')">
            <el-input v-model="yt.conditions.operator"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain>
              {{ $t("sousuo") }}
            </el-button>
            <el-button @click="yt.clear({ createTimeStart: begin(), createTimeEnd: end() })">{{ $t("chongzhi") }} </el-button>
            <yi_curd_expand_button :isAutoExpand="true"></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <template #shifoubulu="scope">
        <span v-if="scope.row.type == 0">
          {{ $t("fou") }}
        </span>
        <span v-if="scope.row.type == 1">
          {{ $t("shi") }}
        </span>
      </template>

      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')" :loading="yt.exportLoading" @click="exportExcel()"></el-button>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
    </yi_curd_table>
  </div>
</template>
<script type="text/javascript">
export default {
  name: "web_production_management_delete_record_list",

  data() {
    return {
      list: [],
      columns: [
        {
          label: "shanchushijian",
          prop: "createTime",
          type: "time",
          width: 130,
        },
        {
          label: "shanchucaozuoren",
          prop: "createByObject.nickname",
          width: 130,
        },
        {
          label: "shengchangongdanhao",
          prop: "wo.no",
          width: 130,
        },
        {
          label: "ERPgongdanhao",
          prop: "wo.erpNo",
          width: 130,
        },
        {
          label: "shebeimingcheng",
          prop: "equipment.name",
          width: 130,
        },
        {
          label: "mujubianhao",
          prop: "mould.no",
          width: 130,
        },
        {
          label: "mujumingcheng",
          prop: "mould.name",
          width: 130,
        },
        {
          label: "chanpinbianma",
          prop: "material.code",
          width: 130,
        },
        {
          label: "chanpinmingcheng",
          prop: "material.name",
          width: 130,
        },
        {
          label: "gongxugongdan",
          prop: "woProcedure.no",
        },
        {
          label: "gongxumiaoshu",
          prop: "woProcedure.procedureDesc",
          width: 130,
        },

        {
          label: "baogongshuliang",
          prop: "quantity",
          width: 130,
        },

        {
          label: "buliangshuliang",
          prop: "badQuantity",
          width: 130,
        },
        {
          label: "jiqijilushuliang",
          prop: "machineQuantity",
          width: 130,
        },
        {
          label: "chayishuliang",
          prop: "diffQuantity",
          width: 130,
        },
        {
          label: "baogongriqi",
          prop: "reportDate",
          type: "time",
          width: 180,
          format: "YYYY-MM-DD",
        },
        {
          label: "baogongbanci",
          prop: "shift.name",
          width: 130,
        },
        {
          label: "tibaoshijian",
          prop: "reportTime",
          type: "time",
          width: 180,
          // format: 'yyyy-MM-dd:hh:mm:ss'
        },
        {
          label: "jiqijilukaishishijian",
          prop: "startTime",
          type: "time",
          width: 180,
          // format: 'yyyy-MM-dd:hh:mm:ss'
        },
        {
          label: "jiqijilujieshushijian",
          prop: "endTime",
          type: "time",
          width: 180,
          // format: 'yyyy-MM-dd:hh:mm:ss'
        },
        {
          label: "caozuoren",
          prop: "reportOperatorObject.nickname",
          width: 130,
        },
        {
          label: "shifoubulu",
          prop: "type",
          type: "slot",
          width: 130,
        },
        {
          label: "beizhu",
          prop: "remark",
          width: 130,
        },
      ],
    };
  },
  created() {
    setTimeout(() => {
      // this.yt.get(1);
      this.yt.get(1, this.beforeGet);
      this.$set(this.yt.conditions, "createTimeStart", this.begin());
      this.$set(this.yt.conditions, "createTimeEnd", this.end());
      this.yt.list = [];
    }, 300);
  },
  methods: {
    beforeGet(params) {
      params["createTimeStart"] = this.begin();
      params["createTimeEnd"] = this.end();
      return params;
    },

    exportExcel() {
      this.yt.exportLoading = true;
      let params = this.yt.conditions;
      return this.http
        .get("/web/report/export/wo_delete_record", {
          params,
        })
        .then((res) => {
          this.$message.success(this.$t(res.msg));
          this.utils.event_hub.$emit("SHOW_HEADER_EXPORT_DIALOG");
        })
        .catch((error) => {
          this.$message.error(this.$t(error));
        })
        .finally(() => {
          this.yt.exportLoading = false;
        });
    },
    begin() {
      const date = new Date();
      const begin = new Date(date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + "01" + " 00:00:00").getTime();
      return begin;
    },
    end() {
      const date = new Date();
      const end = new Date(date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate() + " " + date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds()).getTime();
      return end;
    },
    // 重置
    // clear() {
    // 	this.yt.conditions = {
    // 		createTimeStart: this.begin(),
    // 		createTimeEnd: this.end()
    //
    // 	}
    // 	this.yt.list = []
    // },
  },
};
</script>
